// Shared state (simple store pattern, but really, just global state) between components.
// We do not care about mutations yet, because ... it's simple.

export default {
  timer: {
    time: 0,
    display: false
  },
  progress: {
    total: 0,
    completed: 0
  }
}
